import React, { ReactElement, useEffect, useState } from 'react';
import * as Types from 'types/types';

function convertToSymbols(text: string): string {
  return text
    .replace(/\(R\)/g, '®')
    .replace(/\(C\)/g, '©')
    .replace(/\(TM\)/g, '™');
}

export const SystemInfoComponent: React.FC<{
  systemInfo: Types.SystemInfo | undefined;
}> = ({ systemInfo }) => {
  const [systemElements, setSystemElements] = useState<ReactElement[]>([]);

  useEffect(() => {
    if (systemInfo === undefined) {
      return;
    }
    const elements = Object.entries(systemInfo).flatMap(([k, v]) => {
      if (Array.isArray(v)) {
        return v.map((card, index) => (
          <div key={index} className="SystemInfoItem">
            <div>
              {convertToSymbols(k)} {index}
            </div>
            <div>
              {convertToSymbols(card.name)}{' '}
              {card.discrete
                ? `w/ ${Math.round(card.memory / (1024 * 1024 * 1024))}GB RAM`
                : '(integrated)'}
            </div>
          </div>
        ));
      }

      return (
        <div key={k} className="SystemInfoItem">
          <div>{convertToSymbols(k)}</div>
          <div>{convertToSymbols(String(v))}</div>
        </div>
      );
    });

    setSystemElements(elements);
  }, [systemInfo]);

  return <div className="SystemInfo">{systemElements}</div>;
};
